import { getDuration } from '@/util/helpers';
import axios from '@axios';
import moment from 'moment';

const base = '/api/v1/social-visits/booking-slots';

export default {
  getAllBookingSlots() {
    return axios.get(`${base}/prison/all`);
  },
  setAllBookingSlotsInactive(prisonId) {
    return axios.put(`${base}/mark-all-as-inactive/${prisonId}`);
  },
  getBookingSlotsWithStockForLocation(prisonId, locationId) {
    return axios.get(`${base}/availability/prison/${prisonId}/location/${locationId}`);
  },
  createBookingSlot(bookingSlotCreateDto) {
    return axios.post(`${base}/create/`, bookingSlotCreateDto);
  },
  getBookingSlotSingle(bookingSlotId) { // needs replacing with real endpoint
    return axios.get(`${base}/prison/single/${bookingSlotId}`);
  },
  updateBookingSlot(bookingSlotId, updateDto) { // needs replacing with real endpoint
    return axios.put(`${base}/update/${bookingSlotId}`, updateDto);
  },
  getWeekdays() {
    return ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  },
  getHours() {
    return ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14',
      '15', '16', '17', '18', '19', '20', '21', '22', '23'];
  },
  getMinutes() {
    return ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
  },
  getDuplicatedDates(slots, day, slotBegin, slotEnd, slotId = null, visitLocationId) {
    const overlap = [];

    slots.forEach(slot => {
      if (slotId === null || slotId !== slot._id) { // if an id is passed, exclude as it's an update
        if (slot.day_of_week === day && slot.active) {
          const checkOne = getDuration(slot.slot_begin, slotEnd);
          const checkTwo = getDuration(slotBegin, slot.slot_end);

          // Check if the time ranges overlap
          if (checkOne > 0 && checkTwo > 0) {
            // Check if the visit_location_id matches
            if (slot.visit_location.visit_location_id === visitLocationId) {
              overlap.push(slot);
            }
          }
        }
      }
    });

    return overlap;
  },
  getOverlapName(slot) {
    let name = `${slot.day_of_week} ${slot.slot_begin}-${slot.slot_end}`;

    if (slot.start_date) {
      name += ` during date range: ${moment(slot.start_date).format('DD-MM-YYYY')}`;

      if (slot.end_date) {
        name += `- ${moment(slot.end_date).format('DD-MM-YYYY')}`;
      }
    }

    return name;
  },
  /**
   * If a slot passed does not have a date range, just return the slots and
   * behave like normal
   *
   * Otherwise, the slot is only a duplicate if the date range overlaps, non
   * date range slots are allowed since they are different periods
   *
   *
   * @param slotsToCheck
   * @param slot
   * @returns {*}
   */
  filterDuplicatesByDateRange(slotsToCheck, slot) {
    if (!slot.start_date && !slot.end_date) { // if no start and end on passed slot, no duplicates to filter
      return slotsToCheck;
    }

    return slotsToCheck.filter(item => {
      if (!item.start_date && !item.end_date) { // no start and end, still a duplicate (old slot, no dates)
        return true;
      }

      // if overlap, allow duplicate to stay
      return this.checkDateOverlap(slot.start_date, item.start_date, item.end_date);
    });
  },
  checkDateOverlap(dateToCheck, startDate, endDate) {
    if (!startDate && !endDate) { // if no dates, no overlap
      return false;
    }
    const before = moment(dateToCheck).isSameOrAfter(startDate);

    if (!endDate) { // if no end date, overlaps if start date is after date
      return before;
    }

    const after = moment(dateToCheck).isSameOrBefore(endDate);

    return before && after;
  },
};
